/**
 * Print Entity page
 *
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Component, Injector, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NavController, ToastController, LoadingController, Platform, ModalController, NavParams } from '@ionic/angular';
import { Printer, PrintOptions } from '@awesome-cordova-plugins/printer/ngx';
import { DomSanitizer, Title } from '@angular/platform-browser';
/**
 * Services
 */
import { PouchService } from '../services/pouch-service';
import { ImageService } from '../services/image';
import { Functions } from '../services/functions';
declare var html2pdf;
@Component({
  selector: 'page-print-entity',
  templateUrl: 'print-entity.html',
  styleUrls: ['print-entity.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PrintEntityPage {
  navParams = {};
  options: PrintOptions = {
    name: 'Document',
    //printerId: 'printer007',
    duplex: true,
    //landscape: false,
    //grayscale: true
  };
  // for laboratory report
  labtests = [];
  units = {};
  entity: any;
  extra = null;
  bio = null;
  objectKeys = Object.keys;
  mode = 'laboratoryrequest';
  subscriptions: any = {};
  setting: any;
  hidelist = [];
  arraytags_fields = {};
  barcodetext = '';
  images: any = {};
  labellist = ['input', 'number', 'currency', 'text', 'select', 'checkbox', 'generate_id', 'date', 'datetime-local', 'signature', ''];
  canview = false;
  date = new Date().toISOString();
  logo = '';
  loading: any;
  title = '';

  constructor(
    injector: Injector,
    private titleService: Title,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public toastController: ToastController,
    public func: Functions,
    private platform: Platform,
    public _DomSanitizer: DomSanitizer,
    public imageService: ImageService,
    private printer: Printer,
    public db: PouchService,
    private router: Router,
    public navCtrl: NavController
  ) {
    let navParams2: any = {};
    if (router.url != '/PrintEntityPage') {
      navParams2 = injector.get(NavParams);
    }
    this.navParams = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state != undefined ? this.router.getCurrentNavigation().extras.state : navParams2.data;
    this.entity = this.navParams['entity'];
    if (this.navParams != undefined && this.navParams['extra'] != undefined) {
      this.extra = this.navParams['extra'];
    }
    if (this.navParams != undefined && this.navParams['bio'] != undefined) {
      this.bio = this.navParams['bio'];
    }
    if (this.navParams != undefined && this.navParams['images'] != undefined) {
      this.images = this.navParams['images'];
    }
    if (this.navParams != undefined && this.navParams['title'] != undefined) {
      this.title = this.navParams['title'];
    }
    if (this.navParams != undefined && this.navParams['hidelist'] != undefined) {
      this.hidelist = this.navParams['hidelist'];
    }
    this.mode = this.navParams['mode'];
    this.titleService.setTitle(`Print ${this.mode} - ${this.db.gsetting.username} - ${this.db.appinfo.title}`);

    /*  // upgrade gsetting
    if (this.db.gsetting.qrcode == undefined) {
      this.db.gsetting.qrcode = true;
      this.db.update(this.db.gsetting, 'setting');
    } */
    if (this.mode == 'prescription' && db.gsetting.qrcode) {
      this.barcodetext = `https://apps.sarutech.com/customer/${this.db.gsetting.username}/prescription/${this.entity.id}`;
    } else {
      this.barcodetext = this.entity.id;
    }

    // get labtests
    if (this.mode == 'laboratoryrequest') {
      this.loadEntity('labtest');
      this.arraytags_fields['specimen'] = ['specimen_date', 'arrival_date', 'name', 'taken_by_name'];
    }
    this.entity = this.setAttachmentData(this.entity);
    //images load key images data from attachments
    if (this.entity.attachment_data != undefined) {
      Object.keys(this.entity.attachment_data).map((filename) => {
        if (this.entity.attachment_data[filename].key_image == undefined || this.entity.attachment_data[filename].key_image) {
          //only view key images
          this.db.getAttachment(this.mode, this.entity.id, filename).then((file) => {
            this.blobToDataURL(file, (dataurl) => {
              this.images[filename] = dataurl;
            });
          });
        }
      });
    }
    if (this.db.gsetting.attachments != undefined && this.db.gsetting.attachments.logo != undefined) {
      this.db.getAttachment('setting', this.db.gsetting.id, 'logo').then((file) => {
        this.blobToDataURL(file, (dataurl) => {
          this.logo = dataurl;
        });
        //this.logo = URL.createObjectURL(file);
      });
    }
    this.proceed();
  }

  async proceed() {
    if (this.navParams != undefined && this.navParams['setting'] != undefined) {
      this.setting = this.navParams['setting'];
    } else {
      this.setting = await this.db.get(this.mode, 'setting');
    }
    this.setting.keys = this.setting.keys.filter((key) => !this.hidelist.includes(key) && !this.hidelist.includes(this.setting[key].type)); // do not show hidden keys on the page template
    this.setting.keys.map((key) => {
      if (this.setting[key].type == 'arrayinput') {
        this.generateArrayInputSpreasheet(key, this.entity.unit);
      }
    });
    this.canview = true;
    /* setTimeout(() => {
      if (this.navParams != undefined && this.navParams['view'] != true) {
        this.db.print(this.options);
      }
    }, 1000);
    window.onafterprint = () => {
      if (this.navParams != undefined && this.navParams['view'] != true) {
        // this.navCtrl.pop();
      }
    }; */
  }

  generateArrayInputSpreasheet(key, unit = null) {
    let array = [];
    this.entity[key].map((test) => {
      let item = {
        name: test.name,
        value: test.is_parent ? '' : test.val,
        highlighted: true,
      };
      if (unit) {
        item[unit] = test.is_parent ? '' : test[unit];
      }
      array.push(item);
      if (test.children) {
        test.children.map((child) => {
          let child_item = {
            name: child.name,
            value: child.val,
            highlighted: false,
          };
          if (unit) {
            child_item[unit] = child[unit];
          }
          array.push(child_item);
        });
      }
    });
    this.entity[key] = array;
    this.setting[key] = {
      type: 'spreadsheet',
      required: false,
      val: '',
      options: ['name', 'value'],
    };
    if (this.entity.unit) {
      this.setting[key].options.push(this.entity.unit);
    }
  }

  cleanLabel(label) {
    // remove _name from label and replace _ with space
    return label?.replace('_name', '').replace('_', ' ');
  }

  setAttachmentData(entity) {
    //repair attachment data
    if (entity.attachment_data == undefined) {
      entity.attachment_data = {};
    }
    if (entity.attachments != undefined) {
      Object.keys(entity.attachments).map((filename) => {
        if (entity.attachment_data[filename] == undefined) {
          entity.attachment_data[filename] = {
            note: '',
            name: filename.replace(/\.[^/.]+$/, ''),
          };
        }
      });
    }
    return entity;
  }

  // load other entities
  loadEntity(mode) {
    this.subscriptions[mode] = this.db.getAllRx(mode).subscribe(async (entitys) => {
      this[mode + 's'] = entitys;
    });
  }

  removeAt(key) {
    // remove @ from key and replace _ with space
    return key?.replace('@', '').replace('_', ' ');
  }

  // replace _ with space
  replace(key) {
    return key?.replace('_', ' ');
  }

  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }

  async downloadPDF() {
    this.loading = await this.loadingCtrl.create({
      message: `${this.db.rename('Please wait')}...`,
    });
    await this.loading.present();
    var element = document.getElementById('print-content');
    var opt = {
      margin: 1,
      filename: this.entity.name + '.pdf',
      image: { type: 'jpg', quality: 0.95 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
    };

    /* html2pdf().from(element).toPdf().get('pdf').then(function (pdf) {
      pdf.addPage();
    }).toPdf().save(); */
    // New Promise-based usage:
    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(async (res) => {
        await this.loading.dismiss();
      });
    //html2pdf(document.getElementById('print-content'));
  }

  blobToDataURL(blob, callback) {
    var a = new FileReader();
    a.onload = function (e) {
      callback(e.target.result);
    };
    a.readAsDataURL(blob);
  }

  help(page) {
    window.open('https://sarutech.com/documentation/' + page);
  }

  cancel() {
    //cancel action
    this.modalCtrl.dismiss();
  }
}
